import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml'})

export class sanitizeHtmlPipe implements PipeTransform  {
desc:any;
  constructor(private _sanitizer:DomSanitizer) { }
  transform(value:string):SafeHtml {
    this.desc=  this.toHTML(value);
     return this._sanitizer.bypassSecurityTrustHtml(this.desc);
  }
  toHTML(input) : any {
      return new DOMParser().parseFromString(input, "text/html").documentElement.textContent;
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/pipes/sanitiser.pipe.ts